
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qualitaetskriterien",
      function () {
        return require("private-next-pages/qualitaetskriterien/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qualitaetskriterien"])
      });
    }
  